export const SlaComplianceStatus = {
    EXCLUDED: 1,
    WITHIN_SLA: 2,
    ABOVE_SLA: 3,
};

export const SlaComplianceStatusLabels = {
    [SlaComplianceStatus.EXCLUDED]: 'Excluded',
    [SlaComplianceStatus.WITHIN_SLA]: 'Within SLA',
    [SlaComplianceStatus.ABOVE_SLA]: 'Above SLA',
};
